import React from "react";
import { PDFViewer, StyleSheet } from "@react-pdf/renderer";
// import BcPdf from "../component/BcPdf";
import { useContext } from "react";
import AuthContext from "../store/AuthContext";
import BcPdf from "../component/IrctcPdf";
import IrctcPdf from "../component/IrctcPdf";
const styles = StyleSheet.create({
  viewer: {
    width: window.innerWidth, //the pdf viewer will take up all of the width and height
    height: window.innerHeight,
  },
});

const IrctcCertificate = () => {
  const authCtx = useContext(AuthContext);
  const user = authCtx.user;
  return (
    <PDFViewer style={styles.viewer}>
      <IrctcPdf user={user} />
    </PDFViewer>
  );
};

export default IrctcCertificate;
